import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    scrollContent: {
      padding: 20,
      paddingBottom: 40,
    },
    header: {
      alignItems: 'center',
      marginBottom: 24,
    },
    proIcon: {
      marginBottom: 12,
    },
    title: {
      fontSize: 28,
      fontWeight: 'bold',
      marginBottom: 8,
    },
    subtitle: {
      fontSize: 16,
      textAlign: 'center',
      lineHeight: 22,
    },
    currentPlanBadge: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 8,
      borderRadius: 20,
      marginTop: 12,
    },
    currentPlanText: {
      fontSize: 14,
      fontWeight: '600',
      marginLeft: 6,
    },
    featuresSection: {
      marginBottom: 24,
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: '600',
      marginBottom: 12,
    },
    featureRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
    },
    featureIcon: {
      width: 32,
    },
    featureText: {
      fontSize: 15,
      flex: 1,
    },
    comparisonSection: {
      marginBottom: 24,
    },
    comparisonHeader: {
      flexDirection: 'row',
      paddingVertical: 12,
      borderBottomWidth: 2,
    },
    comparisonFeatureHeader: {
      flex: 2,
      fontSize: 14,
      fontWeight: '600',
    },
    comparisonPlanHeader: {
      flex: 1,
      fontSize: 14,
      fontWeight: '600',
      textAlign: 'center',
    },
    comparisonRow: {
      flexDirection: 'row',
      paddingVertical: 12,
      borderBottomWidth: 1,
      alignItems: 'center',
    },
    comparisonFeature: {
      flex: 2,
      fontSize: 14,
    },
    comparisonValue: {
      flex: 1,
      fontSize: 14,
      textAlign: 'center',
    },
    pricingSection: {
      marginBottom: 24,
    },
    planCard: {
      borderRadius: 12,
      borderWidth: 2,
      padding: 20,
      marginBottom: 12,
    },
    planCardSelected: {
      borderWidth: 2,
    },
    planCardHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 4,
    },
    planName: {
      fontSize: 18,
      fontWeight: '600',
    },
    savingsBadge: {
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 12,
    },
    savingsText: {
      fontSize: 12,
      fontWeight: '600',
    },
    planPrice: {
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 2,
    },
    planPeriod: {
      fontSize: 14,
    },
    subscribeButton: {
      borderRadius: 12,
      paddingVertical: 16,
      alignItems: 'center',
      marginBottom: 12,
    },
    subscribeButtonText: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#fff',
    },
    restoreButton: {
      alignItems: 'center',
      paddingVertical: 12,
      marginBottom: 12,
    },
    restoreButtonText: {
      fontSize: 15,
    },
    legalText: {
      fontSize: 12,
      textAlign: 'center',
      lineHeight: 18,
      paddingHorizontal: 20,
    },
    alreadyProSection: {
      alignItems: 'center',
      padding: 20,
    },
    alreadyProTitle: {
      fontSize: 22,
      fontWeight: 'bold',
      marginTop: 12,
      marginBottom: 8,
    },
    alreadyProSubtitle: {
      fontSize: 15,
      textAlign: 'center',
      lineHeight: 22,
    },
    periodInfo: {
      marginTop: 16,
      paddingHorizontal: 20,
      paddingVertical: 12,
      borderRadius: 12,
    },
    periodInfoText: {
      fontSize: 14,
      textAlign: 'center',
    },
  });
